import React, { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import VerticalMenu from "../../../UI/VerticalMenu";
import classes from "./MainMenu.module.css"
import { useDispatch, useSelector } from 'react-redux';
import TopicsMenu from "./TopicsMenu";
import StudentsMenu from "./StudentsMenu";
import * as PathRouter from '../../../../models/PathRoute'
import { participantsApi } from '../../../../utils'
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import { ParticipantTypeEnumText } from "../../../../models/ParticipantTypeEnum";
import TeamsMenuWrapper from "./TeamsMenuWarrper/TeamsMenuWrapper";

const MainMenu = ({ topicsData }) => {
    const texts = useSelector(state => state.translate.texts);
    const homeUrl = useSelector((state) => state.application.homeUrl);
    const navigate = useNavigate()
    const location = useLocation()
    const [currentIndex, setCurrentIndex] = useState(-1);
    const [studentsData, setStudentsData] = useState()
    const pathList = [PathRouter.LEARNING_TRACKING_MAIN, PathRouter.STUDENTS_LAYOUT, PathRouter.ASSESSMENTS, PathRouter.STUDENT_TRACKING, PathRouter.LESSON, PathRouter.TEAMS]
    const { id, guid } = useParams();
    const dispatch = useDispatch()

    useEffect(() => {
        fetchStudentsData()
    }, [id])

    useEffect(() => {
        setCurrentIndex(pathList.findIndex((p) => location.pathname.toLowerCase().includes(p.toLowerCase())) - 1)
    }, [location.pathname])

    async function fetchStudentsData() {
        const participantsRangeFilter = {
            studyGroupId: id,
            participantType: ParticipantTypeEnumText.student
        }

        participantsApi.participantsFilterRangePost({ participantsRangeFilter }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.participantsFilterError, error: error, statusCode: response?.statusCode, message: "participantsFilterRangePost " + error.message, level: 2, component: "MainMenu", line: 60 }))
                navigate(homeUrl)
            }
            else {
                setStudentsData(response.body)
            }
        })
    }

    return (
        <div className={classes.TopicsMenuWarrper}>
            {currentIndex !== -1 ? <div>
                <VerticalMenu currentIndex={currentIndex}>
                    <div title={texts.studentsLayout}>
                        <TopicsMenu topicsData={topicsData} currentUrl={PathRouter.STUDENTS_LAYOUT} selectSubMenu={true} selectMenu={true}></TopicsMenu>
                    </div>
                    <div title={texts.assessments}>
                        <TopicsMenu topicsData={topicsData} currentUrl={PathRouter.ASSESSMENTS} selectSubMenu={true} selectMenu={true} showAllAssessments={true}></TopicsMenu>
                    </div>
                    <div title={texts.viewStudents}>
                        <StudentsMenu studentsData={studentsData} currentUrl={PathRouter.STUDENT_TRACKING}></StudentsMenu>
                    </div>
                    <div title={texts.viewLessons}>
                        <TopicsMenu topicsData={topicsData} currentUrl={PathRouter.LESSON} selectSubMenu={false}></TopicsMenu>
                    </div>
                    <div title={texts.divisionIntoTeams}>
                        <TeamsMenuWrapper homeUrl={homeUrl}>
                            <TopicsMenu lessonId={guid} topicsData={topicsData} currentUrl={`${PathRouter.TEAMS}`} selectSubMenu={false} disableTopicTitle={true}></TopicsMenu>
                        </TeamsMenuWrapper>
                    </div>
                </VerticalMenu>
            </div> : <></>}
        </div >
    )
}

export default MainMenu